var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandDownicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-327.477 221.912-585.565 296-659.653l184 184 184-184 74.088 74.088L480-327.477Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandDownicon);
export default __webpack_public_path__ + "static/media/expandDown.icon.e5b945189ff100456f2551a0ce6ea43c.svg";
export { ForwardRef as ReactComponent };